/*
 * Copyright (C) 2025 - present by Potentially
 *
 * Please see distribution for license.
 */

import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { environment } from '@app/environments/environment';
import { TableauViz, Toolbar } from '@tableau/embedding-api';
import { PAGES_DATA_SERVICE, PageDataService } from '../../../services/data.service';

@Component({
  selector: 'ptl-page-tableau-section',
  templateUrl: './page-tableau-section.component.html',
  styleUrls: ['./page-tableau-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTableauSectionComponent implements AfterViewInit, OnDestroy {
  @Input() pageUid: string;
  @Input() languageCode: string;

  @ViewChild('tableauViz') tableauVizRef: ElementRef<HTMLDivElement>;

  private subscriptionEnd$ = new EventEmitter<void>();

  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PAGES_DATA_SERVICE) private pageDataService: PageDataService,
  ) {}

  ngAfterViewInit(): void {
    if (this.pageUid) {
      this.pageDataService.getTableauToken(this.pageUid).subscribe(({ isSuccess, value }) => {
        if (isSuccess) {
          this.addMissingWidth();
          const viz = new TableauViz();
          viz.src = this.getJiscTableauUrl();
          viz.token = value.token;
          viz.toolbar = Toolbar.Top;
          this.tableauVizRef.nativeElement.appendChild(viz);
        }
        this.cdr.detectChanges();
      });
    }
  }

  ngOnDestroy() {
    this.subscriptionEnd$?.emit();
  }

  private getJiscTableauUrl(): string {
    if (environment.env === 'dev') {
      return 'https://prod-uk-a.online.tableau.com/#/site/jiscembeddedtableauanalytics/views/DigitalCapabilitiesDashboard_17519623447430/Welcomepage?:customViews=no';
    }
    if (environment.env === 'prod') {
      return 'https://prod-uk-a.online.tableau.com/t/jiscembeddedtableauanalytics/views/DigitalCapabilitiesDashboard/Welcomepage';
    }

    throw new Error('Invalid environment');
  }

  private addMissingWidth(): void {
    setTimeout(() => {
      const layoutContainer = document.querySelector('.f-page-layout__container') as HTMLElement;
      const buttonsContainer = document.querySelector('.f-content-view-admin-buttons-container') as HTMLElement;
      const missingWidth = 48;

      if (layoutContainer) {
        layoutContainer.style.maxWidth = `${layoutContainer.clientWidth + missingWidth}px`;
      }

      if (buttonsContainer) {
        buttonsContainer.style.maxWidth = `${buttonsContainer.clientWidth + missingWidth}px`;
      }
    }, 300);
  }
}
